import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const instituteBranchOfficeList = createAsyncThunk('instituteBranchOfficeList', async ({ instituteId, navigate, status }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'institute_branch_office',
            params: {
                'institute_id': instituteId,
                ...(status ? { status } : {}),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const instituteBranchOfficeListSlice = createSlice({
    name: 'instituteBranchOfficeList',
    initialState: { data: [] },
    extraReducers: (builder) => {
        builder.addCase(instituteBranchOfficeList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = (() => { const raw = action.payload.data.data; return Array.isArray(raw) ? raw : (Object.values(raw || {}).find(Array.isArray) || []); })();
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
    }
})

export default instituteBranchOfficeListSlice.reducer;
